const UploadIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="currentColor"
    color="inherit"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.87498 22.1667C7.31352 22.1667 6.83288 21.9667 6.43305 21.5669C6.03323 21.1671 5.83331 20.6865 5.83331 20.125V17.0625H7.87498V20.125H20.125V17.0625H22.1666V20.125C22.1666 20.6865 21.9667 21.1671 21.5669 21.5669C21.1671 21.9667 20.6864 22.1667 20.125 22.1667H7.87498ZM12.9791 18.0833V9.76354L10.325 12.4177L8.89581 10.9375L14 5.83333L19.1041 10.9375L17.675 12.4177L15.0208 9.76354V18.0833H12.9791Z" />
  </svg>
);

export default UploadIcon;
